import clsx from 'clsx'
import { Icon } from '@iconify/react'

import { CMP_SALES_CONTACT_URL } from 'utils/constants/website_urls'
import { useGlobalState } from '@pepper/ui'

import s from './TopBanner.module.css'

type Subscription = {
  key: string
  name: string
  status: string
  trialStatus: 'upgraded' | 'expired' | 'active'
}

type Props = {
  handleClose: () => void
  subscription: Subscription | null
}

const TopBanner = ({ handleClose, subscription }: Props): JSX.Element => {
  const { viewport } = useGlobalState()

  const isMobileView = viewport !== 'lg'

  const copyText =
    subscription?.trialStatus === 'expired'
      ? 'Your free trial has expired! Upgrade now to unlock all the features!'
      : '✨You are currently on the trial plan, upgrade now to unlock all the features!'

  return (
    <div className={s.wrapper}>
      <p className={s.copy}>{copyText}</p>
      <div className={s.btnWrapper}>
        <a
          href={CMP_SALES_CONTACT_URL}
          target="_blank"
          rel="noreferrer"
          className={clsx(s.secondaryButton, s.button)}
        >
          Contact Sales
        </a>
      </div>
      {subscription?.trialStatus !== 'expired' && (
        <button className={s.closeBtn} onClick={handleClose}>
          <Icon icon="basil:cross-solid" height={isMobileView ? 32 : 24} />
        </button>
      )}
    </div>
  )
}

export default TopBanner
